import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SelectModule} from 'ng-select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SweetAlert2Module} from '@toverux/ngx-sweetalert2';
import {DataTablesModule} from 'angular-datatables';
import {ModalModule} from 'ngx-bootstrap/modal';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {TabsModule, TimepickerModule} from 'ngx-bootstrap';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { MyActionItemsRoutingModule } from './my-action-items-routing.module';
// import { MyActionManagementComponent } from './my-action-management/my-action-management.component';
import {SharedModule} from "../shared/shared.module";
import {AngularMultiSelectModule} from "angular2-multiselect-dropdown";
import {NgxEditorModule} from "ngx-editor";
import { MyActionAlmahaManagementComponent } from './my-action-almaha-management/my-action-almaha-management.component';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import { MyActionManagementComponent } from './my-action-management/my-action-management.component';
@NgModule({
  imports: [
    CommonModule,
    MyActionItemsRoutingModule,
    SelectModule,
    FormsModule,
    TabsModule.forRoot(),
    ModalModule.forRoot(),
  
    TooltipModule.forRoot(),
    DataTablesModule,
    SharedModule,
    SweetAlert2Module.forRoot({
      buttonsStyling: false,
      customClass: 'modal-content',
      confirmButtonClass: 'btn btn-primary',
      cancelButtonClass: 'btn'
    }),
    AngularMultiSelectModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    PopoverModule.forRoot(),
    NgxEditorModule
  ],
  declarations: [ MyActionAlmahaManagementComponent, MyActionManagementComponent]
})
export class MyActionItemsModule { }



// WEBPACK FOOTER //
// /app/src/app/my-action-items/my-action-items.module.ts